<template>
  <div class="modal">
    <div class="modal-dialog" v-click-outside="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5>I want to snooze the alert:</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="radio">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="snooze"
                id="7-days"
                :value="1"
                v-model="snoozeType"
              />
              <label class="form-check-label" for="7-days">
                For 7 days
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="snooze"
                id="30-days"
                :value="2"
                v-model="snoozeType"
              />
              <label class="form-check-label" for="30-days">
                For 30 days
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="snooze"
                id="pick-date"
                :value="3"
                v-model="snoozeType"
              />
              <label class="form-check-label" for="pick-date">
                For the period:
              </label>
            </div>
          </div>
          <div class="pick-date-input">
            <div class="form-group row" disabled>
              <label for="from" class="col-2 col-form-label">From</label>
              <div class="col-10" disabled>
                <input
                  type="text"
                  class="form-control"
                  id="from"
                  :disabled="snoozeType !== 3"
                  v-model="date.from"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="to" class="col-2 col-form-label">To</label>
              <div class="col-10">
                <input
                  type="text"
                  class="form-control"
                  id="to"
                  placeholder="DD/MM/YYYY"
                  :disabled="snoozeType !== 3"
                  v-model="date.to"
                />
              </div>
            </div>
            <div v-if="warning" class="warning text-danger">{{ warning }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="closeModal"
          >
            Cancel
          </button>

          <button type="button" class="btn btn-primary" @click="submit">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import * as vClickOutside from 'v-click-outside';

import {
  checkIsValidDate,
  transformDateFormatFromDDMMYYYYToYYYYMMDD
} from '../../../utils/common';

export default {
  name: 'SnoozeAlertModal',
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      snoozeType: 1,
      date: {
        from: dayjs().format('DD/MM/YYYY'),
        to: ''
      },
      warning: ''
    };
  },
  watch: {
    date: {
      deep: true,
      handler(val) {
        this.warning = '';
      }
    }
  },
  methods: {
    submit() {
      if (this.snoozeType === 3) {
        const isDateFromValid = checkIsValidDate(this.date.from);
        const isDateToValid = checkIsValidDate(this.date.to);

        if (!isDateFromValid || !isDateToValid) {
          this.warning = 'Please enter a valid date: DD/MM/YYYY.';
        } else {
          const from = transformDateFormatFromDDMMYYYYToYYYYMMDD(
            this.date.from
          );
          const to = transformDateFormatFromDDMMYYYYToYYYYMMDD(this.date.to);

          const isDateFromBeforeDateTo = dayjs(from).isBefore(dayjs(to));

          const isDateToAfterToday = dayjs(to).isAfter(dayjs());

          if (!isDateFromBeforeDateTo) {
            this.warning = 'Start date must be earlier than end date.';
          } else if (!isDateToAfterToday) {
            this.warning = 'End date must be later than today.';
          } else {
            const val = {
              snoozeFrom: dayjs(from).toISOString(),
              snoozeTo: dayjs(to).toISOString()
            };

            this.$emit('onSetSnooze', val);
          }
        }
      } else {
        const val = {
          snoozeFrom: dayjs().toISOString(),
          snoozeTo:
            this.snoozeType === 1
              ? dayjs()
                  .add(7, 'day')
                  .toISOString()
              : dayjs()
                  .add(30, 'day')
                  .toISOString()
        };

        this.$emit('onSetSnooze', val);
      }
    },
    closeModal() {
      this.$emit('onCloseModal');
    }
  },
  mounted() {
    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        this.closeModal();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}

.modal-dialog {
  max-width: initial;
  width: 22rem;
}

.modal-header {
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;

  h5 {
    margin: 0;
    font-size: 1rem;
  }
}

.modal-body {
  margin: 0 1rem;

  .radio {
    margin: 0;

    .form-check {
      margin-bottom: 1rem;
    }
  }

  .pick-date-input {
    position: relative;
    margin: 1rem;

    input {
      width: 10rem;
    }

    .warning {
      position: absolute;
      top: 6rem;
      font-size: 0.8rem;
      white-space: nowrap;
    }
  }
}

.modal-footer {
  justify-content: space-evenly;
}
</style>
